import { Component, HostListener, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './shared/core/auth.service';
import { NavigationHistoryService } from './shared/services/navigation-history.service';

@Component({
  selector: 'mida-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly navigationHistory = inject(NavigationHistoryService);

  ngOnInit(): void {
    void this.authService.initializeSession();
  }

  @HostListener('document:click')
  @HostListener('document:mousedown')
  @HostListener('document:keydown')
  @HostListener('document:scroll')
  @HostListener('document:touchstart')
  userActivity() {
    this.authService.onUserActivity();
  }
}
